import type { IconName } from "@mdotm/shadcn/legacy/components";

export class LocalizedError extends Error {
	constructor(
		public endUserMsg: string,
		opts?: { cause?: unknown; msg?: string },
	) {
		super(opts?.msg, { cause: opts?.cause });
	}
}

export class UserCancelledError extends Error {
	constructor(msg?: string, opts?: { cause?: unknown }) {
		super(msg ?? "action cancelled by the user", opts);
	}
}

export class ToastableError extends LocalizedError {
	public icon: IconName | undefined;
	/** Shows the message's "- " lines as a list and keeps the toast open longer. */
	public listLines: boolean;

	constructor(
		public endUserMsg: string,
		opts?: { cause?: unknown; msg?: string; icon?: IconName; listLines?: boolean },
	) {
		super(endUserMsg, { msg: opts?.msg, cause: opts?.cause });
		this.icon = opts?.icon ?? "Icon-full-alert";
		this.listLines = opts?.listLines ?? false;
	}
}

export function tryOrFallback<T>(tryFn: () => T, fallback: T): T {
	try {
		return tryFn();
	} catch (err) {
		console.warn("[tryOrDefault] tryFn threw an exception, proceeding with fallback value", err);
		return fallback;
	}
}
